const { debounce } = require('@/utils');

module.exports = (s) => {
  return {
    channel_interface: {
      label: '渠道接口',
      type: 'select',
      value: s.initOps.channel_interface,
      formItemProps: {
        class: ['hidden'],
      },
    },
    advertiser_id: {
      label: '广告主ID',
      type: 'select',
      value: s.initOps.advertiser_ids[0],
      formItemProps: {
        class: ['hidden'],
      },
    },
    max_text_length: {
      label: '文案最长字数限制',
      type: 'input-number',
      value: s.pageConfig.rules.max_length,
      formItemProps: {
        class: ['hidden'],
      },
    },
    number: {
      label: '返回文案最大数量',
      type: 'input-number',
      value: 200,
      formItemProps: {
        class: ['hidden'],
      },
    },
    category_first_level: {
      label: '一级行业类型（固定值）',
      type: 'select',
      value: 21474836523,
      formItemProps: {
        class: ['hidden'],
      },
      options: [],
    },
    category_second_level: {
      label: '游戏类型',
      type: 'select',
      value: '',
      props: {
        placeholder: '请选择游戏类型',
      },
      options: s.$store ? s.$store.getters.gdtEnum.api_v3_game_category_second_level : [],
      on: {
        change() {
          s.emitConfirmEvent();
        },
      },
    },
    keyword: {
      label: '关键词',
      type: 'input',
      value: '',
      props: {
        placeholder: '请输入搜索关键词',
      },
      on: {
        input: debounce(s.emitConfirmEvent, 500),
      },
    },
    text_types: {
      label: '文案类型',
      type: 'select',
      value: '',
      props: {
        multiple: true,
        collapseTags: true,
        placeholder: '请选择文案类型',
      },
      options: [
        { label: 'HOT', value: 0 },
        { label: 'CTR高', value: 1 },
      ],
      on: {
        change(val) {
          s.dispatchFilteringSort(val);
          s.emitConfirmEvent();
        },
      },
    },
  };
};
